export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5454.59faf1ab.jpg";